module.exports = __webpack_public_path__ + "img/LOGO_SIRAT_couleur.c0bc129a.png";